export default __webpack_public_path__ + "media/images/candidat-new-87965b56497bc92bc49a4756dcae4c56.png";